export const START_INDEX = 10 ** 7;
